import PageHeader from "../../components/common/PageHeader";
import Table from "../../components/common/Table";
import StatusBadge from "../../components/common/StatusBadge";
import { formatDate } from "../../utils/HelperMethod";
import { useState } from "react";
import Pagination from "../../components/common/Pagination";
import SearchBar from "../../components/common/Search";
import CustomFilterDropdown from "../../components/common/CustomFilterDropdown";
import { useAdminPayouts } from "../../custom-hooks/queries";

export default function PaymentManagement() {
  const [currentPage, setCurrentPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const pageSize = 20;
  const statusOptions = [
    { id: "Paid", name: "Paid" },
    { id: "Upcoming", name: "Upcoming" },
    { id: "Failed", name: "Failed" },
  ];

  const { data, isLoading, isError } = useAdminPayouts({
    page: currentPage,
    pageSize,
    search: searchText,
    status: statusFilter,
    fromDate,
    toDate,
  });

  const payouts =
    data?.data?.data?.payouts?.map((item) => ({
      transactionId: item.transactionId,
      vendorName: item.vendorName,
      amount: item.amount,
      status: item.status,
      payoutDate: item.payoutDate,
    })) || [];

  const columns = [
    {
      key: "transactionId",
      label: "TRANSACTION ID",
      width: "1.6fr",
      align: "left",
      render: (row) => (
        <span className="font-semibold text-gray-900 truncate">
          {row.transactionId}
        </span>
      ),
    },
    {
      key: "vendorName",
      label: "VENDOR",
      width: "1.6fr",
      align: "left",
      render: (row) => (
        <span className="text-gray-700 truncate">{row.vendorName}</span>
      ),
    },
    {
      key: "amount",
      label: "AMOUNT",
      width: "1fr",
      align: "center",
      render: (row) => (
        <span className="font-medium text-gray-900">${row.amount}</span>
      ),
    },
    {
      key: "status",
      label: "STATUS",
      width: "1.2fr",
      align: "center",
      render: (row) => <StatusBadge status={row.status} />,
    },
    {
      key: "payoutDate",
      label: "DATE",
      width: "1.4fr",
      align: "center",
      render: (row) => (
        <span className="text-sm text-gray-600">
          {formatDate(row.payoutDate)}
        </span>
      ),
    },
  ];

  const handleSearch = (value) => {
    setSearchText(value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="px-4 py-1 sm:px-6 sm:py-1">
      <PageHeader
        title="Payment Management"
        description="Track and manage vendor payouts"
      />

      <div className="bg-white rounded-[12px] border border-[#D9D9D9] shadow-sm overflow-hidden mt-4 sm:mt-6">
        {/* Search + Filters */}
        <div className="flex flex-col sm:flex-row justify-between gap-4 py-6 sm:py-10 px-4 sm:px-6">
          <SearchBar onSearch={handleSearch} />

          <CustomFilterDropdown
            options={statusOptions}
            onChange={setStatusFilter}
            placeholder="Filter by Status"
            valueKey="id"
            labelKey="name"
          />
        </div>

        {isError ? (
          <div className="flex justify-center items-center py-20 text-red-500">
            Failed to load payouts.
          </div>
        ) : (
          <Table
            columns={columns}
            data={payouts}
            isLoading={isLoading}
            skeletonRows={pageSize}
          />
        )}
      </div>

      {!isLoading && !isError && data?.data?.data?.totalPages > 1 && (
        <div className="mt-4 sm:mt-6">
          <Pagination
            currentPage={currentPage}
            totalPages={data?.data?.data?.totalPages || 1}
            onPageChange={handlePageChange}
          />
        </div>
      )}
    </div>
  );
}
